module.exports = __webpack_public_path__ + "img/portfolio-09-670x479.01882bc6.jpg";